import { render, staticRenderFns } from "./EditorHeaderReportButtonPPT.vue?vue&type=template&id=5a68ad62&scoped=true"
import script from "./EditorHeaderReportButtonPPT.vue?vue&type=script&lang=js"
export * from "./EditorHeaderReportButtonPPT.vue?vue&type=script&lang=js"
import style0 from "./EditorHeaderReportButtonPPT.vue?vue&type=style&index=0&id=5a68ad62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a68ad62",
  null
  
)

export default component.exports